"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _styles = require("@mui/styles");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _Home = _interopRequireDefault(require("@mui/icons-material/Home"));
var _CreditCard = _interopRequireDefault(require("@mui/icons-material/CreditCard"));
var _MonetizationOn = _interopRequireDefault(require("@mui/icons-material/MonetizationOn"));
var _Receipt = _interopRequireDefault(require("@mui/icons-material/Receipt"));
var _BarChart = _interopRequireDefault(require("@mui/icons-material/BarChart"));
var _ListAlt = _interopRequireDefault(require("@mui/icons-material/ListAlt"));
var _InsertInvitation = _interopRequireDefault(require("@mui/icons-material/InsertInvitation"));
var _ShoppingCart = _interopRequireDefault(require("@mui/icons-material/ShoppingCart"));
var _Person = _interopRequireDefault(require("@mui/icons-material/Person"));
var _ContactSupport = _interopRequireDefault(require("@mui/icons-material/ContactSupport"));
var _ExitToApp = _interopRequireDefault(require("@mui/icons-material/ExitToApp"));
var _theme = require("../theme/");
var _Text = _interopRequireDefault(require("../components/Text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // import { logout } from '../actions/user';
var Sidebar = /*#__PURE__*/function (_Component) {
  function Sidebar() {
    var _this;
    (0, _classCallCheck2["default"])(this, Sidebar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Sidebar, [].concat(args)), _this.state = {
      selectedScreen: 'dashboard',
      options: [{
        title: "Dashboard",
        icon: /*#__PURE__*/_react["default"].createElement(_Home["default"], null),
        view: "dashboard",
        link: "/"
      }, {
        title: "Drug Card",
        icon: /*#__PURE__*/_react["default"].createElement(_CreditCard["default"], null),
        view: "drug-card",
        link: "/drug-card"
      }, {
        title: "Spending Accounts",
        icon: /*#__PURE__*/_react["default"].createElement(_MonetizationOn["default"], null),
        view: "spending-accounts",
        link: "/spending-accounts"
      }, {
        title: "Claims",
        icon: /*#__PURE__*/_react["default"].createElement(_Receipt["default"], null),
        view: "claims",
        link: "/claims"
      }, {
        title: "My Usage",
        icon: /*#__PURE__*/_react["default"].createElement(_BarChart["default"], null),
        view: "usage",
        link: "/usage"
      }, {
        title: "Plan Coverage",
        icon: /*#__PURE__*/_react["default"].createElement(_ListAlt["default"], null),
        view: "coverage",
        link: "/coverage"
      }, {
        title: "Appointments",
        icon: /*#__PURE__*/_react["default"].createElement(_InsertInvitation["default"], null),
        view: "appointments",
        link: "/appointments"
      }, {
        title: "Marketplace",
        icon: /*#__PURE__*/_react["default"].createElement(_ShoppingCart["default"], null),
        view: "marketplace",
        link: "/marketplace"
      }],
      metaOptions: [{
        title: "My Account",
        icon: /*#__PURE__*/_react["default"].createElement(_Person["default"], null),
        view: "account",
        link: "/my-account"
      }, {
        title: "Support",
        icon: /*#__PURE__*/_react["default"].createElement(_ContactSupport["default"], null),
        view: "support",
        link: "/support"
      }]
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(Sidebar, _Component);
  return (0, _createClass2["default"])(Sidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var selectedScreen = '';
      var href = window.location.href;
      if (href.includes('drug-card')) {
        selectedScreen = 'drug-card';
      } else if (href.includes('spending-accounts')) {
        selectedScreen = 'spending-accounts';
      } else if (href.includes('my-account')) {
        selectedScreen = 'account';
      } else if (href.includes('claims')) {
        selectedScreen = 'claims';
      } else if (href.includes('usage')) {
        selectedScreen = 'usage';
      } else if (href.includes('coverage')) {
        selectedScreen = 'coverage';
      } else if (href.includes('appointments')) {
        selectedScreen = 'appointments';
      } else if (href.includes('marketplace')) {
        selectedScreen = 'marketplace';
      } else if (href.includes('support')) {
        selectedScreen = 'support';
      } else {
        selectedScreen = 'dashboard';
      }
      this.setState({
        selectedScreen: selectedScreen
      });
    }

    /*
     * Use with redux
     * _logout = () => {
     *     this.props.dispatch(logout());
     * };
     */
  }, {
    key: "render",
    value: function render() {
      var _require,
        _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        id = _this$props.id,
        testid = _this$props.testid;
      var _this$state = this.state,
        options = _this$state.options,
        metaOptions = _this$state.metaOptions;
      var email = this.props.user.email;
      var name = "".concat(this.props.user.firstname, " ").concat(this.props.user.lastname);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.sidebar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.sidebarHeader
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: "/",
        className: classes.titleLink
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "Simply Benefits Logo",
        src: (_require = require('../../src/assets/logo-medium.png')) === null || _require === void 0 ? void 0 : _require["default"],
        className: classes.logoSmall
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        margin: "10px 0 0 0"
      }, name), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, email)), /*#__PURE__*/_react["default"].createElement("div", {
        id: id || testid,
        className: classes.sidebarBody
      }, /*#__PURE__*/_react["default"].createElement(_List["default"], null, options && options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          key: option.title,
          to: option.link,
          style: {
            textDecoration: 'none'
          },
          onClick: _this2.props.closeSideBar
        }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
          button: true,
          className: "".concat(classes.listItem, " ").concat(_this2.state.selectedScreen === option.view ? classes.selected : null)
        }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, option.icon), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          primary: option.title
        })));
      }), /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
        variant: "middle",
        style: {
          margin: 20
        }
      }), metaOptions && metaOptions.map(function (metaOption) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          key: metaOption.title,
          to: metaOption.link,
          style: {
            textDecoration: 'none'
          },
          onClick: _this2.props.closeSideBar
        }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
          button: true,
          className: "".concat(classes.listItem, " ").concat(_this2.state.selectedScreen === metaOption.view ? classes.selected : null)
        }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, metaOption.icon), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          primary: metaOption.title
        })));
      }), /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
        button: true,
        className: classes.listItem,
        onClick: this._logout
      }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_ExitToApp["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
        primary: "Logout"
      })))));
    }
  }]);
}(_react.Component);
/**
 *
 * @param {*} theme
 */
var styles = function styles(theme) {
  return {
    sidebar: {
      backgroundColor: _theme.colors.surface,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%'
    },
    sidebarHeader: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: _theme.colors.subHeaderGrey,
      flex: 0.2,
      minHeight: '200px'
    },
    sidebarBody: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: _theme.colors.backgroundGrey,
      flex: 1,
      padding: '10px 30px'
    },
    listItem: {
      margin: '5px 0px',
      cursor: 'pointer'
    },
    logoSmall: {
      width: '60px'
    },
    selected: {
      backgroundColor: _theme.colors.backgroundGrey
    }
  };
};
Sidebar.propTypes = {
  user: _propTypes["default"].object
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(Sidebar); // When using the sidebar in an app with redux, add the following:
// /**
//  *
//  * @param {*} state
//  */
// const mapStateToProps = (state) => ({
//     user: state.user.meta
// });
// export default withStyles(styles)(connect(mapStateToProps)(Sidebar));